/**
 * /!\ Please considere local imports instead of global ones /!\
 *
 * Case where global imports are allowed :
 * - Usage of a Vue components in a backend template (PHP / XSL)
 */
import PopupPanel from 'vcomponents/PopupPanel.vue';
import ObjectList from 'vcomponents/utilities/ObjectList.vue';
import ConfirmDelete from 'vcomponents/utilities/ConfirmDelete.vue';
import SellsyListing from 'vcomponents/listing/Listing.vue';
import PipelineListing from 'vcomponents/listing/PipelineListing.vue';
import Report from 'vcomponents/report/Report.vue';
import OverviewTemp from 'vcomponents/overview/OverviewTemp.vue';

import Bonus from 'vcomponents/bonus/Bonus.vue';
import DocOverview from 'vcomponents/documents/DocOverview.vue';
import PurOverview from 'vcomponents/purchases/PurOverview.vue';
import CatalogOverview from 'vcomponents/catalog/CatalogOverview.vue';
import BankReconciliationDocumentForm from 'vcomponents/bankreconciliation/DocumentForm.vue';
import BankPref from 'vcomponents/preferences/Bank.vue';
import DunningPref from 'vcomponents/preferences/Dunning/Dunning.vue';
import DocDisplayPref from 'vcomponents/preferences/DocDisplay.vue';
import DocConformityPref from 'vcomponents/preferences/DocConformity.vue';
import PurOrderDisplayPref from 'vcomponents/preferences/PurOrderDisplay.vue';
import DocMainPref from 'vcomponents/preferences/DocMain.vue';
import DocTaxPref from 'vcomponents/preferences/DocTax.vue';
import SaleDocPaymentPref from 'vcomponents/preferences/SaleDocPaymentPref.vue';
import CountersPref from 'vcomponents/preferences/Counters.vue';
import FiscalYearPref from 'vcomponents/preferences/FiscalYear.vue';
import WarehouseRemain from 'vcomponents/stock/WarehouseRemain.vue';
import Overview from 'vcomponents/overview/Overview.vue';
import OverviewStaff from 'vcomponents/overview/OverviewStaff.vue';
import OnboardingStaff from 'vcomponents/onboarding/OnboardingStaff.vue';
import AgedBalance from 'vcomponents/accounting/AgedBalance.vue';
import MapListing from 'vcomponents/listing/MapListing.vue';
import SAMSubscriptionForm from 'vcomponents/sellsyaccountmanager/SubscriptionForm.vue';
import SubscriptionManager from 'vcomponents/sellsyaccountmanager/SubscriptionManager.vue';
import ChargebeeSubscriptionManagerV3 from 'vcomponents/sellsyaccountmanager/SubscriptionManager/chargebeeSubscriptionManagerV3/ChargebeeSubscriptionManagerV3.vue';
import ErrorLicenseStaff from 'vcomponents/pages/errors/ErrorLicenseStaff.vue';
import ErrorLicenseAdmin from 'vcomponents/pages/errors/ErrorLicenseAdmin.vue';
import TrialEndCartExpired from 'vcomponents/pages/errors/TrialEndCartExpired.vue';
import TrialEndCartAvailable from 'vcomponents/pages/errors/TrialEndCartAvailable.vue';
import BasicCartExpired from 'vcomponents/pages/errors/BasicCartExpired.vue';
import BasicCartAvailable from 'vcomponents/pages/errors/BasicCartAvailable.vue';
import ErrorCartExpired from 'vcomponents/pages/errors/ErrorCartExpired.vue';
import ErrorBasic from 'vcomponents/pages/errors/ErrorBasic.vue';
import ErrorBlocked from 'vcomponents/pages/errors/ErrorBlocked.vue';
import FullPageTermsForm from 'vcomponents/sellsyaccountmanager/FullPageTermsForm.vue';
import Cgvu from 'vcomponents/pages/terms/CGVU.vue';
import BillingSettings from 'vcomponents/sellsyaccountmanager/billingsettings/BillingSettings.vue';
import Stripe3dSecure from 'vcomponents/forms/Stripe3dSecure.vue';
import CompanySearchPrefForm from 'vcomponents/companysearch/CompanySearchPrefForm.vue';
import Menu from 'vcomponents/menu/Menu.vue';
import Notifications from 'vcomponents/header/Notifications.vue';
import HeaderOnboardingScreen from 'vcomponents/header/HeaderOnboardingScreen.vue';

import mobileAppBanner from 'vcomponents/mobileApp/mobileAppBanner.vue';
import NotificationInApp from 'vcomponents/pages/settings/notification/NotificationInApp.vue';
import ComplianceImpersonate from 'vcomponents/pages/settings/complianceImpersonate/ComplianceImpersonate.vue';
import DoubleAuthentication from 'vcomponents/pages/settings/doubleAuthentication/doubleAuthentication.vue';
import Nav from 'vcomponents/header/Nav.vue';

import TryRocketchart from 'vcomponents/cashflow/TryRocketchart.vue';

import BankreconciliationImport from 'vcomponents/bankreconciliation/BankreconciliationImport.vue';
import OcrList from 'vcomponents/ocr/OcrList.vue';
import OcrVerificationForm from 'vcomponents/ocr/OcrVerificationForm.vue';

import Conformity from 'vcomponents/settings/sellsymodule/invoicing/Conformity.vue';
import ConformitySettings from 'vcomponents/settings/sellsymodule/invoicing/ConformitySettings.vue';
import AutomaticAccountingRecording from 'vcomponents/settings/sellsymodule/accounting/AutomaticAccountingRecording.vue';
import FastSearch from 'vcomponents/fastsearch/FastSearch.vue';
import GlobalLoading from 'vcomponents/utilities/GlobalLoading.vue';
import FastSearchSwitcher from 'vcomponents/fastsearch/FastSearchSwitcher.vue';

import EmailSettingsAccount from 'vcomponents/email/EmailSettingsAccount.vue';
import EmailListingDomainAuthBanner from 'vcomponents/email/EmailListingDomainAuthBanner.vue';
import SettingsEmailDomain from 'vcomponents/pages/settings/email/SettingsEmailDomain.vue';

import NotFound from 'vcomponents/errors/NotFound.vue';

import ProviderExternMailingConf from 'vcomponents/preferences/ProviderExternMailingConf.vue';

import VatSettings from 'vcomponents/settings/taxes/VatSettings.vue';
import SettingsAccountingCharts from 'vcomponents/settings/sellsymodule/accounting/SettingsAccountingCharts.vue';
import NotificationHandler from 'vcomponents/notifications/NotificationHandler.vue';
import NotificationBanner from 'vcomponents/notifications/NotificationBanner.vue';

import EmailPanelHandler from 'vcomponents/email/emailPanels/EmailPanelHandler.vue';

// inputs

import CfSimpleText from 'vcomponents/inputs/custom/SimpleText.vue';
import CfRichText from 'vcomponents/inputs/custom/RichText.vue';
import CfNumeric from 'vcomponents/inputs/custom/Numeric.vue';
import CfAmount from 'vcomponents/inputs/custom/Amount.vue';
import CfUnit from 'vcomponents/inputs/custom/Unit.vue';
import CfEmail from 'vcomponents/inputs/custom/Email.vue';
import CfUrl from 'vcomponents/inputs/custom/Url.vue';
import CfDate from 'vcomponents/inputs/custom/Date.vue';
import CfCheckbox from 'vcomponents/inputs/custom/Checkbox.vue';
import CfSelect from 'vcomponents/inputs/custom/Select.vue';
import CfRadio from 'vcomponents/inputs/custom/Radio.vue';
import CfTime from 'vcomponents/inputs/custom/Time.vue';
import CfThird from 'vcomponents/inputs/custom/Third.vue';
import CfPeople from 'vcomponents/inputs/custom/People.vue';
import CfItem from 'vcomponents/inputs/custom/Item.vue';
import CfStaff from 'vcomponents/inputs/custom/Staff.vue';
import CfBoolean from 'vcomponents/inputs/custom/Boolean.vue';

// Pages
import OverviewThird from 'vcomponents/pages/OverviewThird.vue';
import OverviewPeople from 'vcomponents/pages/OverviewPeople.vue';
import OverviewOpportunity from 'vcomponents/pages/OverviewOpportunity.vue';
import AffiliationErrorPage from 'vcomponents/pages/errors/AffiliationErrorPage.vue';
import UpsellPage from 'vcomponents/pages/UpsellPage.vue';
import MarketingLandingPage from 'vcomponents/marketing/landing/MarketingLandingPage.vue';
import MarketingConfigurePage from 'vcomponents/marketing/configure/MarketingConfigurePage.vue';
import MarketingConfigureErrorPage from 'vcomponents/marketing/configure/MarketingConfigureErrorPage.vue';
import ConsentDoubleOptinConfirmationPage from 'vcomponents/consent/ConsentDoubleOptinConfirmationPage.vue';
import ConsentDoubleOptinErrorPage from 'vcomponents/consent/ConsentDoubleOptinErrorPage.vue';
import ConsentOptinUpdatePage from 'vcomponents/consent/ConsentOptinUpdatePage.vue';
import GoogleGranularConsentErrorPage from 'vcomponents/consent/GoogleGranularConsentErrorPage.vue';
import AcademyPage from 'vcomponents/academy/AcademyPage.vue';

import Connection from 'vcomponents/sellsyadmin/Connection.vue';

import SettingsEmail from 'vcomponents/settings/SettingsEmail.vue';
import SettingsEmailsTemplates from 'vcomponents/settings/emails/SettingsEmailsTemplates.vue';
import UnitSettings from 'vcomponents/preferences/UnitSettings.vue';
import CompanyInformationSettings from 'vcomponents/preferences/CompanyInformation/CompanyInformation.vue';
import SettingsMandate from 'vcomponents/settings/SettingsMandate.vue';

import SettingsMenu from 'vcomponents/settings/SettingsMenu.vue';
import Nologo from 'vcomponents/appearance/noLogo.vue';

import ReportBanner from 'vcomponents/report/ReportBanner.vue';
import Heading from 'vcomponents/common/Heading/Heading.vue';
import PageLayoutSettings from 'vcomponents/common/layout/pages/PageLayoutSettings.vue';

import MandateConformityBanner from 'vcomponents/pa/MandateConformityBanner.vue';

import KpiList from 'vcomponents/utilities/KpiList.vue';
import Margin from 'vcomponents/documents/overview/tab/Margin.vue';
import Dunning from 'vcomponents/documents/overview/tab/Dunning.vue';

import DocBonusForm from 'vcomponents/documents/DocBonusForm.vue';
import BonusForm from 'vcomponents/bonus/BonusForm.vue';
import DocCancelByCreditNote from 'vcomponents/documents/DocCancelByCreditNote.vue';
import DocChangeByCreditNote from 'vcomponents/documents/DocChangeByCreditNote.vue';
import DocEditRowAccountingCode from 'vcomponents/documents/DocEditRowAccountingCode.vue';
import OverviewNav from 'vcomponents/overview/OverviewNav.vue';
import BackListing from 'vcomponents/overview/BackListing.vue';
import ValidationPopup from 'vcomponents/documents/overview/menu/ValidationPopup.vue';
import AnnotationsTab from 'vcomponents/pages/overview/AnnotationsTab.vue';
import LoaderWithFallback from 'vcomponents/utilities/LoaderWithFallback.vue';
import Preloader from 'vcomponents/utilities/Preloader.vue';
import CopyLink from 'vcomponents/utilities/CopyLink.vue';
import DocumentEmail from 'vcomponents/documents/DocumentEmail.vue';
import DocumentSendEmail from 'vcomponents/documents/DocumentSendEmail.vue';
import DocumentStatusEditInPlace from 'vcomponents/documents/DocumentStatusEditInPlace/DocumentStatusEditInPlace.vue';
import DocumentTagWrapper from 'vcomponents/documents/DocumentTagWrapper/DocumentTagWrapper.vue';
import SettingsImportComponent from 'vcomponents/settings/import/SettingsImportComponent.vue';

const components = {
    'main-menu': Menu,
    navigation: Nav,
    'header-notifications': Notifications,
    ComplianceImpersonate,
    'header-onboarding-screen': HeaderOnboardingScreen,
    NotificationInApp,
    DoubleAuthentication,
    PopupPanel,
    ObjectList,
    Overview,
    OverviewTemp,
    'slsy-listing': SellsyListing,
    'slsy-map-listing': MapListing,
    ConfirmDelete,
    PipelineListing,
    OnboardingStaff,
    'sam-subscription-form': SAMSubscriptionForm,
    SubscriptionManager,
    ChargebeeSubscriptionManagerV3,
    ErrorLicenseStaff,
    ErrorLicenseAdmin,
    TrialEndCartAvailable,
    TrialEndCartExpired,
    BasicCartAvailable,
    BasicCartExpired,
    ErrorCartExpired,
    ErrorBasic,
    ErrorBlocked,
    FullPageTermsForm,
    Cgvu,
    BillingSettings,
    CompanySearchPrefForm,
    'stripe-3d-secure': Stripe3dSecure,
    AgedBalance,
    OverviewStaff,
    DocOverview,
    PurOverview,
    CatalogOverview,
    Bonus,
    BankPref,
    FiscalYearPref,
    CountersPref,
    DunningPref,
    WarehouseRemain,
    DocDisplayPref,
    DocConformityPref,
    PurOrderDisplayPref,
    DocMainPref,
    DocTaxPref,
    'doc-payment-pref': SaleDocPaymentPref,
    Report,
    'rb-document-form': BankReconciliationDocumentForm,
    BankreconciliationImport,
    CfSimpleText,
    CfRichText,
    CfNumeric,
    CfAmount,
    CfUnit,
    CfEmail,
    CfUrl,
    CfDate,
    CfCheckbox,
    CfSelect,
    CfRadio,
    CfTime,
    CfThird,
    CfPeople,
    CfItem,
    CfStaff,
    CfBoolean,
    'ocr-list': OcrList,
    'ocr-verification-form': OcrVerificationForm,
    conformity: Conformity,
    ConformitySettings,
    FastSearch,
    GlobalLoading,
    AutomaticAccountingRecording,
    FastSearchSwitcher,
    EmailSettingsAccount,
    SettingsEmailDomain,
    EmailListingDomainAuthBanner,
    NotFound,
    ProviderExternMailingConf,
    TryRocketchart,
    VatSettings,
    SettingsAccountingCharts,
    NotificationHandler,
    NotificationBanner,
    SettingsImportComponent,
    AffiliationErrorPage,
    UpsellPage,
    EmailPanelHandler,
    MarketingLandingPage,
    MarketingConfigurePage,
    MarketingConfigureErrorPage,
    Connection,
    SettingsEmail,
    ConsentDoubleOptinConfirmationPage,
    ConsentDoubleOptinErrorPage,
    ConsentOptinUpdatePage,
    GoogleGranularConsentErrorPage,
    Nologo,
    mobileAppBanner,
    ReportBanner,
    SettingsEmailsTemplates,
    SettingsMandate,
    AcademyPage,
    OverviewNav,
    BackListing,
    KpiList,
    SettingsMenu,
    Heading,
    UnitSettings,
    Margin,
    Dunning,
    DocBonusForm,
    DocCancelByCreditNote,
    DocChangeByCreditNote,
    DocEditRowAccountingCode,
    ValidationPopup,
    AnnotationsTab,
    Preloader,
    LoaderWithFallback,
    CopyLink,
    DocumentEmail,
    DocumentSendEmail,
    DocumentStatusEditInPlace,
    DocumentTagWrapper,
    PageLayoutSettings,
    BonusForm,
    CompanyInformationSettings,
    MandateConformityBanner,
};

const pages = {
    OverviewThird,
    OverviewPeople,
    OverviewOpportunity,
};

export default { ...components, ...pages };
